"use strict";
function identity(x) {
    return x;
}
exports.identity = identity;
//# sourceMappingURL=identity.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/util/identity.js
// module id = 709
// module chunks = 22